<template>
  <div class="d-flex justify-center mt-10">
    <v-card width="400px" tile>
      <v-card-title>SignUp</v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="isValid">
          <v-text-field
            label="Mobile Number"
            :rules="rules.phone"
            dense
            outlined
            v-model="form.phone"
          >
          </v-text-field>
          <v-text-field
            label="Username"
            :rules="rules.password"
            dense
            outlined
            v-model="form.username"
          >
          </v-text-field>
          <v-text-field
            label="Email"
            dense
            outlined
            :rules="rules.email"
            v-model="form.email"
          >
          </v-text-field>
          <v-text-field
            label="Password"
            :rules="rules.password"
            dense
            outlined
            v-model="form.password"
          >
          </v-text-field>
        </v-form>
        <v-btn block class="primary" @click="submit" depressed tile>
          Login</v-btn
        >
      </v-card-text>
      <VerifyOTP ref="otp" @success="$emit('success')"></VerifyOTP>
    </v-card>
  </div>
</template>

<script>
import { EMAIL, FIELD, PHONE } from "../../assets/js/rules";
import userService from "../../assets/services/user.service";
import VerifyOTP from "./VerifyOTP.vue";
export default {
  components: { VerifyOTP },
  data() {
    return {
      isValid: false,
      rules: {
        phone: PHONE,
        email: EMAIL,
        password: FIELD,
      },
      res: {},
      form: {},
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    async submit() {
      const vm = this;
      vm.$refs.form.validate();
      if (!vm.isValid) return;
      let { phone, password, email, username } = vm.form;
      let params = {
        Email: email,
        City: "*",
        Address: "*",
        Companyname: "*",
        Aadharno: "*",
        Panno: "*",
        Gstno: "*",
        State: "*",
        user_subtype: "*",
        MobileNo: phone,
        Password: password,
        username,
        authkey: vm.user.AuthKey,
        source: "JSON",
      };
      try {
        vm.$loader.show();
        let res = await userService.register(params);
        let { status, message } = res.data;
        vm.res = {};
        vm.$loader.hide();
        if (status == "SetOtp") {
          vm.res.AuthKey = message;
          vm.$refs.otp.init({ phone, password }, message);
          return;
        }
        vm.$alert.show(message);
      } catch (error) {
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    },
  },
};
</script>

<style>
</style>